import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export const CalloutType = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  TIP: 'tip',
} as const;

export type CalloutTypeType = (typeof CalloutType)[keyof typeof CalloutType];

export const CalloutVariant = {
  INFORMATIVE: 'informative',
  PROMOTIONAL: 'promotional',
} as const;

export type CalloutVariantType =
  (typeof CalloutVariant)[keyof typeof CalloutVariant];

export type CalloutProps = {
  id?: string;
  testId?: string;
  type?: CalloutTypeType;
  variant?: CalloutVariantType;
  title?: string;
  description?: string;
  iconName?: TUNDR_ICONS;
};
